/**
 * SECTION 5B JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 5B, data
         * UI interaction functions etc
         */
        console.log( 'Section 5B - init' );
        
        //var where_do_you_take_inspiration = '';
        
        this.aon_section_5b_data = [];
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 1A...
            if ( $( '#section_5b_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        // Render Data...
        this.renderData();
        
        
        // Click on "True or False" buttons...
        $( 'body' ).on( 'click', '.true-or-false button', function( event ) {
            $( '.true-or-false-next' ).removeClass( 'disabled' );
            $( '.true-or-false-answer' ).removeClass( 'hide' );
            $( '.true-or-false .false' ).addClass( 'active' );
            $( '.true-or-false .true' ).addClass( 'disabled' );
            event.preventDefault();
        });
        
        $( 'body' ).on( 'click change', '.option.positive', function( event ) {
            $( '.positive-negative .positive' ).addClass( 'active' );
            if ( $( '.positive-negative .positive' ).hasClass( 'active' ) && $( '.positive-negative .negative' ).hasClass( 'active' ) ) {
                $( '.positive-negative-next' ).removeClass( 'disabled' );
            }
            event.preventDefault();
        });
        
        $( 'body' ).on( 'click change', '.option.negative', function( event ) {
            $( '.positive-negative .negative' ).addClass( 'active' );
            if ( $( '.positive-negative .positive' ).hasClass( 'active' ) && $( '.positive-negative .negative' ).hasClass( 'active' ) ) {
                $( '.positive-negative-next' ).removeClass( 'disabled' );
            }
            event.preventDefault();
        });
        
        
        /*
         * Add / Edit Modal interaction...
         */
        
        var lists_add_edit_modal_mode = '';
        
        // Click to Edit existing Lists entry modal link...
        $( 'body' ).on( 'click', '.lists_entry a', function( event ) {
            lists_add_edit_modal_mode = 'edit';
            
            // natural_materials`, `recycled_materials` or `add_values
            var lists_entry_type = $( this ).attr( 'data-lists-entry-type' );
            var id = $( this ).attr( 'data-lists-entry-id' );
            
            if ( lists_entry_type == 'recycled_materials' ) { // Show only two columns for this entry type
                // Get label values
                var lists_entry_title_field_1_label = $( '#' + lists_entry_type + '_list .list-headings .heading_1' ).text();
                var lists_entry_title_field_2_label = $( '#' + lists_entry_type + '_list .list-headings .heading_2' ).text();
                
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_1"] span' ).text( lists_entry_title_field_1_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_2"] span' ).text( lists_entry_title_field_2_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"] span' ).text( '' );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"]' ).addClass( 'hide' );
                
                // Get field values
                var lists_entry_title_field_1 = $( '.field-1', this ).text();
                var lists_entry_title_field_2 = $( '.field-2', this ).text();
                
                $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_1' ).val( lists_entry_title_field_1 );
                $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_2' ).val( lists_entry_title_field_2 );
                $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_3' ).val( '' );
                
            } else { // Show default three columns for all other entries
                // Get label values
                var lists_entry_title_field_1_label = $( '#' + lists_entry_type + '_list .list-headings .heading_1' ).text();
                var lists_entry_title_field_2_label = $( '#' + lists_entry_type + '_list .list-headings .heading_2' ).text();
                var lists_entry_title_field_3_label = $( '#' + lists_entry_type + '_list .list-headings .heading_3' ).text();
                
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_1"] span' ).text( lists_entry_title_field_1_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_2"] span' ).text( lists_entry_title_field_2_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"] span' ).text( lists_entry_title_field_3_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"]' ).removeClass( 'hide' );
                
                // Get field values
                var lists_entry_title_field_1 = $( '.field-1', this ).text();
                var lists_entry_title_field_2 = $( '.field-2', this ).text();
                var lists_entry_title_field_3 = $( '.field-3', this ).text();
                
                $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_1' ).val( lists_entry_title_field_1 );
                $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_2' ).val( lists_entry_title_field_2 );
                $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_3' ).val( lists_entry_title_field_3 );
                
            }
            
            $( '#list_5b_add_edit_entry_modal #lists_entry_type' ).val( lists_entry_type );
            $( '#list_5b_add_edit_entry_modal #lists_entry_id' ).val( id );
            
            //console.log( 'Start opening Lists Modal...');
            openListsModal();
            //console.log( 'Done opening Lists Modal...');
            
            event.preventDefault();
        });
		
		// List entry hover / highlighting...
        $( 'body' ).on( 'mouseenter', '.lists_entry', function() {
			$( this ).find( $( '.lists-entry-edit-tooltip' ) ).remove();
			var edit_tooltip = $( '.lists-entry-edit-tooltip.hide' ).clone();
			edit_tooltip.removeClass( 'hide' );
			$( this ).append( edit_tooltip );
        });

        $( 'body' ).on( 'mouseleave', '.lists_entry', function() {
			$( this ).find( $( '.lists-entry-edit-tooltip' ) ).remove();
        });
		
        
        var openListsModal = () => { // Function defined using arrow method to gain access to main 'this'
            //console.log( 'Called opening Lists Modal...');
            $( '#list_5b_add_edit_entry_modal' ).foundation( 'open' );
        }
        
        
        // Click on Add Lists entry modal link...
        $( 'body' ).on( 'click', '.lists_entry_add_edit a', function( event ) {
            lists_add_edit_modal_mode = 'add';
            
            var lists_entry_type = $( this ).attr( 'data-lists-add-entry-type' ); // natural_materials`, `recycled_materials` or `add_values`
            
            console.log( 'lists_entry_type: ' + lists_entry_type );
            
            if ( lists_entry_type == 'recycled_materials' ) { // Show only two columns for this entry type
                var lists_entry_title_field_1_label = $( '#' + lists_entry_type + '_list .list-headings .heading_1' ).text();
                var lists_entry_title_field_2_label = $( '#' + lists_entry_type + '_list .list-headings .heading_2' ).text();
                
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_1"] span' ).text( lists_entry_title_field_1_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_2"] span' ).text( lists_entry_title_field_2_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"] span' ).text( '' );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"]' ).addClass( 'hide' );
                
            } else { // Show default three columns for all other entries
                var lists_entry_title_field_1_label = $( '#' + lists_entry_type + '_list .list-headings .heading_1' ).text();
                var lists_entry_title_field_2_label = $( '#' + lists_entry_type + '_list .list-headings .heading_2' ).text();
                var lists_entry_title_field_3_label = $( '#' + lists_entry_type + '_list .list-headings .heading_3' ).text();
                
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_1"] span' ).text( lists_entry_title_field_1_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_2"] span' ).text( lists_entry_title_field_2_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"] span' ).text( lists_entry_title_field_3_label );
                $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"]' ).removeClass( 'hide' );
                
            }
            
            console.log( 'lists_entry_title_field_1_label: ' + lists_entry_title_field_1_label );
            console.log( 'lists_entry_title_field_2_label: ' + lists_entry_title_field_2_label );
            console.log( 'lists_entry_title_field_3_label: ' + lists_entry_title_field_3_label );
            
            $( '#list_5b_add_edit_entry_modal #lists_entry_type' ).val( lists_entry_type );
            $( '#list_5b_add_edit_entry_modal #lists_entry_id' ).val( '' );
            
            event.preventDefault();
        });
        
        
        // 'Save' button click within Lists entry modal...
        $( 'body' ).on( 'click', '#save_lists_entry', function( event ) {
            // Save data to existing
            var id = $( '#list_5b_add_edit_entry_modal #lists_entry_id' ).val();
            var lists_entry_title_field_1 = aon_craft_utils.removeHTMLTags( $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_1' ).val() );
            var lists_entry_title_field_2 = aon_craft_utils.removeHTMLTags( $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_2' ).val() );
            var lists_entry_title_field_3 = aon_craft_utils.removeHTMLTags( $( '#list_5b_add_edit_entry_modal #lists_entry_title_field_3' ).val() );
            var lists_entry_type = aon_craft_utils.removeHTMLTags( $( '#list_5b_add_edit_entry_modal #lists_entry_type' ).val() );
            if ( lists_add_edit_modal_mode == 'edit' ) {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && lists_entry_title_field_1 != '' && lists_entry_title_field_2 != '' ) {
                    saveExistingListsEntry( id, lists_entry_title_field_1, lists_entry_title_field_2, lists_entry_title_field_3, lists_entry_type );
                }
            } else if ( lists_add_edit_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( lists_entry_title_field_1 != '' && lists_entry_title_field_2 != '' ) {
                    saveNewListsEntry( lists_entry_title_field_1, lists_entry_title_field_2, lists_entry_title_field_3, lists_entry_type );
                }
            } else if ( lists_add_edit_modal_mode == 'delete' ) {
                // Delete...
                deletingExistingListsEntry( id, lists_entry_type );
            }
            
            event.preventDefault();
        });
        
        var saveExistingListsEntry = ( id, lists_entry_title_field_1, lists_entry_title_field_2, lists_entry_title_field_3, lists_entry_type ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_5b_data[ id ][ 'lists_field_1' ] = lists_entry_title_field_1;
            this.aon_section_5b_data[ id ][ 'lists_field_2' ] = lists_entry_title_field_2;
            this.aon_section_5b_data[ id ][ 'lists_field_3' ] = lists_entry_title_field_3;
            this.aon_section_5b_data[ id ][ 'lists_entry_type' ] = lists_entry_type;
            this.renderListEntries( lists_entry_type );
            $( '#list_5b_add_edit_entry_modal' ).foundation( 'close' );
            //console.log( 'SAVE LISTS ENTRY' );
            this.saveData();
        }
        
        var saveNewListsEntry = ( lists_entry_title_field_1, lists_entry_title_field_2, lists_entry_title_field_3, lists_entry_type ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_5b_data.push( { lists_field_1: lists_entry_title_field_1, lists_field_2: lists_entry_title_field_2, lists_field_3: lists_entry_title_field_3, lists_entry_type: lists_entry_type } );
            this.renderListEntries( lists_entry_type );
            $( '#list_5b_add_edit_entry_modal' ).foundation( 'close' );
            this.saveData();
        }
        
        var deletingExistingListsEntry = ( id, lists_entry_type ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_5b_data.splice( id, 1 );
            this.renderListEntries( lists_entry_type );
            $( '#list_5b_add_edit_entry_modal' ).foundation( 'close' );            
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_lists_entry ').text( save_text ); // Save
            $( '#save_lists_entry ').removeClass( 'delete' );            
            this.saveData();
        }
        
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#list_5b_add_edit_entry_modal', function() {
            if ( lists_add_edit_modal_mode == 'edit' ) {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_entry ').text( save_text ); // Save
                $( '#save_entry ').removeClass( 'delete' );
                
                $( '.delete_entry_panel', this ).show();
                
            } else if ( lists_add_edit_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '.delete_entry_panel', this ).hide();
                $( '#lists_entry_title_field_1' ).val( '' );
                $( '#lists_entry_title_field_2' ).val( '' );
                $( '#lists_entry_title_field_3' ).val( '' );
                
                // natural_materials`, `recycled_materials` or `add_values
                var lists_entry_title_field_1 = $( '.list-headings #heading_1', this ).text();
                var lists_entry_title_field_2 = $( '.list-headings #heading_2', this ).text();
                var lists_entry_title_field_3 = $( '.list-headings #heading_3', this ).text();
                var lists_entry_type = $( this ).attr( 'data-lists-entry-type' );
                var id = $( this ).attr( 'data-lists-entry-id' );
                
            }
            $( '#lists_entry_title_field_1' ).focus();
            console.log( 'list_5b_add_edit_entry_modal open' );
            console.log( 'lists_add_edit_modal_mode: ' + lists_add_edit_modal_mode );
        });

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#list_5b_add_edit_entry_modal', function() {
            $( '#lists_entry_title_field_1' ).val( '' );
            $( '#lists_entry_title_field_2' ).val( '' );
            $( '#lists_entry_title_field_3' ).val( '' );
            
            $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_1"] span' ).text( '' );
            $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_2"] span' ).text( '' );
            $( '#list_5b_add_edit_entry_modal label[for="lists_entry_title_field_3"] span' ).text( '' );
            
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_lists_entry ').text( save_text ); // Save
            $( '#save_lists_entry ').removeClass( 'delete' );
            //console.log( 'list_5b_add_edit_entry_modal close' );
        });     
        
        $( 'body' ).on( 'change', '#list_5b_add_edit_entry_modal #delete_entry', function( event ) {
            if ( $( '#list_5b_add_edit_entry_modal #delete_entry' ).prop( 'checked' ) ) {
				var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_lists_entry ').text( delete_text ); // DELETE
                $( '#save_lists_entry ').addClass( 'delete' );
                lists_add_edit_modal_mode = 'delete';
                //console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_text' ).val();
            	$( '#save_lists_entry ').text( save_text ); // Save
                $( '#save_lists_entry ').removeClass( 'delete' );
                lists_add_edit_modal_mode = 'edit';
                //console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
        
        
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
          

    },
    
    renderData() {
        console.log( 'renderData - Section 5B');
        
        // Get any existing saved Lists entry data...
        this.loadData();
        
        // Render List entries...
        this.renderListEntries( 'natural_materials' );
        this.renderListEntries( 'recycled_materials' );
        this.renderListEntries( 'add_values' );
        
    },
    
    renderListEntries( lists_entry_type ) {
        /*
         * Load / render existing entries to 5B...
         */
        console.log( 'renderListEntries - ' + lists_entry_type + ' - start' );
        //console.table( this.aon_section_5b_data );  
        
        // Remove any existing entries so that we don't re-render...
        $( '#' + lists_entry_type + '_list .lists_container li.lists_entry' ).remove();
   
        
        // We get the main headings and add to each entry as data attributes,
        // this is used to dynamically show headings for each entry on small mobile size view. 
        var lists_entry_title_field_1_label = $( '#' + lists_entry_type + '_list .list-headings .heading_1' ).text();
        var lists_entry_title_field_2_label = $( '#' + lists_entry_type + '_list .list-headings .heading_2' ).text();
        var lists_entry_title_field_3_label = $( '#' + lists_entry_type + '_list .list-headings .heading_3' ).text();
        
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_section_5b_data, function( index ) {
            // Begin entry...            
            //var aon_lists_entry_link = '<a href="#edit_lists_entry" data-lists-entry-id="' + index + '" data-lists-entry-type="' + this.lists_entry_type + '" class="entry_' + entry_count + ' ' + this.lists_entry_type + '">' + this.name + '</a>';
            
            if ( lists_entry_type == 'recycled_materials' && this.lists_entry_type == 'recycled_materials' ) { // Show only two columns for this entry type
                var aon_lists_entry_link = '<a href="#edit_lists_entry" data-lists-entry-id="' + index + '" data-lists-entry-type="' + this.lists_entry_type + '" class="entry_' + entry_count + ' ' + this.lists_entry_type + '"><div class="row left-margin-zero right-margin-zero"><div class="column small-12 medium-3 large-3 text-left field-1" data-label="' + lists_entry_title_field_1_label + '">' + this.lists_field_1 + '</div><div class="column small-12 medium-9 large-9 text-left field-2" data-label="' + lists_entry_title_field_2_label + '">' + this.lists_field_2 + '</div></div></a>';
                $( '#recycled_materials_list .lists_container' ).append( '<li class="lists_entry">' + aon_lists_entry_link + '</li>' );
                entry_count++;
                console.log( 'Adding entry to the recycled_materials list.' );
                
            } else if ( lists_entry_type == 'natural_materials' && this.lists_entry_type == 'natural_materials' ) { // Show default three columns for all other entries
                var aon_lists_entry_link = '<a href="#edit_lists_entry" data-lists-entry-id="' + index + '" data-lists-entry-type="' + this.lists_entry_type + '" class="entry_' + entry_count + ' ' + this.lists_entry_type + '"><div class="row left-margin-zero right-margin-zero"><div class="column small-12 medium-3 large-3 text-left field-1" data-label="' + lists_entry_title_field_1_label + '">' + this.lists_field_1 + '</div><div class="column small-12 medium-4 large-4 text-left field-2" data-label="' + lists_entry_title_field_2_label + '">' + this.lists_field_2 + '</div><div class="column small-12 medium-4 large-5 text-left field-3" data-label="' + lists_entry_title_field_3_label + '">' + this.lists_field_3 + '</div></div></a>';
                $( '#natural_materials_list .lists_container' ).append( '<li class="lists_entry">' + aon_lists_entry_link + '</li>' );
                console.log( 'Adding entry to the natural_materials list.' );
                entry_count++;
                
            } else if ( lists_entry_type == 'add_values' && this.lists_entry_type == 'add_values' ) { // Show default three columns for all other entries
                var aon_lists_entry_link = '<a href="#edit_lists_entry" data-lists-entry-id="' + index + '" data-lists-entry-type="' + this.lists_entry_type + '" class="entry_' + entry_count + ' ' + this.lists_entry_type + '"><div class="row left-margin-zero right-margin-zero"><div class="column small-12 medium-3 large-3 text-left field-1" data-label="' + lists_entry_title_field_1_label + '">' + this.lists_field_1 + '</div><div class="column small-12 medium-4 large-4 text-left field-2" data-label="' + lists_entry_title_field_2_label + '">' + this.lists_field_2 + '</div><div class="column small-12 medium-4 large-5 text-left field-3" data-label="' + lists_entry_title_field_3_label + '">' + this.lists_field_3 + '</div></div></a>';
                $( '#add_values_list .lists_container' ).append( '<li class="lists_entry">' + aon_lists_entry_link + '</li>' );
                console.log( 'Adding entry to the add_values list.' );
                entry_count++;
                
            }
            
        });
        
        // If enable / disable Next button depending on whether entries exist...
        //lists_add_edit_next
        //if ( !this.aon_section_5b_data.length ) {
        //    $( '.lists_add_edit_next_' ).addClass( 'disabled' );
        //} else {
        //    $( '.lists_add_edit_next' ).removeClass( 'disabled' );
        //}

    },
    
    addDataEntry() {
        console.log( 'addDataEntry - start' );
        // Default variables for data structure...
        // Push default data to data structure array...
        //this.aon_section_5b_data.push( {} );
        // NOTE: We don't actually push any default data here, it's only when entries are added to lists
        // that any data is added to the data array
        console.log( 'addDataEntry: '  );
        console.table( this.aon_section_5b_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_5b_data_json = $( '#section_5b_data_json' ).val();
			//console.log( 'aon_section_5b_data_json:' );
			//console.log( aon_section_5b_data_json );
            this.aon_section_5b_data = JSON.parse( aon_section_5b_data_json );
            console.table( this.aon_section_5b_data );
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_section_5b_data_json = '[';
                //aon_section_5b_data_json += '{"lists_entries_data":[{"lists_field_1":"Aluminium","lists_field_2":"John","lists_field_3":"The is affected by the mining and smelting of Aluminium / bauxite ore","lists_entry_type":"natural_materials"},{"lists_field_1":"Steel","lists_field_2":"Jim","lists_field_3":"Steel requires smelting which produces emissions","lists_entry_type":"natural_materials"}]}';
                aon_section_5b_data_json += '{"lists_field_1":"Aluminium","lists_field_2":"John","lists_field_3":"The is affected by the mining and smelting of Aluminium / bauxite ore","lists_entry_type":"natural_materials"},{"lists_field_1":"Steel","lists_field_2":"Jim","lists_field_3":"Steel requires smelting which produces emissions","lists_entry_type":"natural_materials"}';
                aon_section_5b_data_json += ']';

            this.aon_section_5b_data = JSON.parse( aon_section_5b_data_json );
            console.table( this.aon_section_5b_data );
            
        } else if ( mode == 'start' ) {
            console.log( '5B LoadData - mode = Start' );
            this.addDataEntry();
            
        }
      
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        
        var jsonDataString = JSON.stringify( this.aon_section_5b_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '5B AJAX - START' );
        var meta = { 'section_5b_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '5B AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_5b_data );
    }

}